<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/FlowProduct/Flow' }">产品审批</el-breadcrumb-item>
            <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <!-- <el-row >
          <el-col :span="18" :offset="3" class="attention">
            <ol>
              <li v-for="(item,index) in attention" :key="index">{{item}}</li>
            </ol>
          </el-col>
      </el-row>-->

      <TaskForm :task="task"></TaskForm>
    </el-card>
  </div>
</template>
<script>
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetFirstStepId } from "../../until/ZeusApiSDK/Logic/WorkFLowLogic";
import TaskForm from "../../views/FlowProduct/TaskForm";
export default {
  data() {
    return {
      flowid: "",
      flowname: "",
      stepid: "",
      pageTitle: "",
      task: {},
      user:{},
    };
  },
  created() {
    this.InitData();
  },
  methods: {
    InitData: function() {
      this.user=GetCurrentUserInfo();
      this.flowid = this.$route.params.flowid;
      this.flowname = this.$route.params.flowname;
      if(!this.flowid&&!this.flowname)
      {
        this.$router.push('/FlowFlowProduct/Flow')        
      }
      this.pageTitle = "发起" + this.flowname;
      this.task.FlowID = this.flowid;
      this.task.StepID ="";
      this.task.InstanceID = "";
      this.task.isFirstStep = true;
      this.task.ID = "";
      this.task.CCID = "";
      this.task.Title = this.user.TrueName+"的"+this.flowname;

    }
  },
  components: {
    TaskForm
  }
};
</script>